import { UpdateTypeRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateCategoryRequest';
import { createTypeHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/TypeHttpRepository';

import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateType = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createTypeHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateTypeRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.update(id, data);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['types'] });
      queryClient.invalidateQueries({ queryKey: ['type', variables.id] });
    },
  });
};
